import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { GlossaryData } from '@reducers/glossary';
import { GlossaryPayload as gp } from '@rootCommon/constants/glossaries';

export const getGlossariesData = (state: RootState): GlossaryData => state.glossary.data;
export const getCountriesData = createSelector(getGlossariesData, (data) => data[gp.COUNTRIES]);
export const getNotificationRulesGlossary = createSelector(getGlossariesData, (data) => data[gp.NOTIFICATION_RULES]);
export const getLanguagesData = createSelector(getGlossariesData, (data) => data[gp.LANGUAGES]);
export const getTimezonesData = createSelector(getGlossariesData, (data) => data[gp.TIMEZONES]);
export const getFacilityTypesData = createSelector(getGlossariesData, (data) => data[gp.FACILITY_TYPES]);
export const getPrefixesData = createSelector(getGlossariesData, (data) => data[gp.PREFIXES]);
export const getSuffixesData = createSelector(getGlossariesData, (data) => data[gp.SUFFIXES]);
export const getJobTitlesData = createSelector(getGlossariesData, (data) => data[gp.JOB_TITLES]);
export const getIpWhitelistModesData = createSelector(getGlossariesData, (data) => data[gp.IP_WHITELIST_MODES]);
export const getCidrsData = createSelector(getGlossariesData, (data) => data[gp.CIDRS]);
